export default {
  recommendedShopsTitle: {
    gb: 'Browse More Items From Top Shops in the UK',
    default: 'Browse Top Shops',
  },
};
